import styled from "styled-components";

export const Wrapper = styled.div`
  margin-bottom: 8px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 33px;
  margin-bottom: 16px;
  padding: 0 16px 0 0;

  svg {
    margin-right: 16.43px;
  }
`;
